import z from 'zod'
import { decimalSchema } from '../../utils/schema'

export const tradeSchema = z.object({
  /** Ask側のアカウントID */
  askAccountId: z.number().nullish(),
  /** Ask側の注文ID */
  askOrderId: z.number().nullish(),
  /** Bid側のアカウントID */
  bidAccountId: z.number().nullish(),
  /** Bid側の注文ID */
  bidOrderId: z.number().nullish(),
  /** 手数料（USDT） */
  fee: decimalSchema,
  /** 取引ID */
  id: z.number(),
  /** 注文タイプ（LIMIT, MARKET, DELEVERAGER） */
  orderType: z.enum(['LIMIT', 'MARKET', 'DELEVERAGER']),
  /** 約定価格 */
  price: decimalSchema,
  /** 約定数量 */
  quantity: decimalSchema,
  /** 実現損益 */
  realizedPnl: decimalSchema,
  /** 売買方向（Buy or Sell） */
  side: z.enum(['Buy', 'Sell']),
  /** 取引ペア（例: ETH/USDT-P） */
  symbol: z.string(),
  /** タイムスタンプ（Unix秒） */
  timestamp: z.number(),
  /** テイカーかどうか（オプション） */
  is_taker: z.boolean().optional(),
  /** サブ秒単位のナノ秒（オプション） */
  timestamp_ns_partial: z.number().optional(),
})

export const tradeHistoryResponseSchema = z.object({
  trades: z.array(tradeSchema),
})

export type Trade = z.infer<typeof tradeSchema>
export type TradeHistoryResponse = z.infer<typeof tradeHistoryResponseSchema>
